import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-launching-digital-services',
  templateUrl: './launching-digital-services.component.html',
  styleUrls: ['./launching-digital-services.component.scss'],
})
export class LaunchingDigitalServicesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
